/**
 * Created by Administrator on 2020/3/24.
 */
// Created by hejikun on 2017/11/2 0002.
let yunnancn = [
  {
    path: '/yunnancn',
    name: '医院列表',
    component: () => import('@/pages/yunnancn/index')
  },
  {
    path: '/ynPhysical',
    name: '体检主页',
    component: () => import('@/pages/yunnancn/ynPhysical')
  },
  {
    path: '/ynPhysicalDetail',
    name: '体检列表',
    component: () => import('@/pages/yunnancn/ynPhysicalDetail')
  },
  {
    path: '/yunnancn_home',
    name: '挂号看病',
    component: () => import('@/pages/yunnancn/yunnancn_home')
  },
  {
    path: '/ynfree',
    name: '免费咨询',
    component: () => import('@/pages/yunnancn/ynfree')
  },
  {
    path: '/ynOnline',
    name: '在线缴费',
    component: () => import('@/pages/yunnancn/ynOnline')
  },
  {
    path: '/ynCommunity',
    name: '先心病专区',
    component: () => import('@/pages/yunnancn/ynCommunity')
  },
  {
    path: '/ynReport',
    name: '报告查询',
    component: () => import('@/pages/yunnancn/ynReport')
  },
]

export default yunnancn
